/* Lior · Pre-Order home page banner (sections/lior-preorder.liquid) */
(function () {
  if (customElements.get('lior-preorder')) return;
  var TZ = 'Asia/Jerusalem';

  class LiorPreorder extends HTMLElement {
    connectedCallback() {
      this.offset = 0;
      this.launch = Date.parse(this.dataset.launch) || 0;
      this.open = false;
      this.closed = false;
      this.units = Array.prototype.slice.call(this.querySelectorAll('[data-u]'));
      this.cd = this.querySelector('[data-cd]');
      this.when = this.querySelector('[data-when]');
      this.openLine = this.querySelector('[data-open-line]');
      this.note = this.querySelector('[data-note]');
      this.ctaText = this.querySelector('[data-cta-text]');
      this.cta = this.ctaText && this.ctaText.parentElement;
      this.reduce = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
      this.painted = false;
      this.render();
      this.tick();
      this.fetchStatus();
      this.poll = setInterval(() => { if (!this.open && !document.hidden && this.left() > 90000) this.fetchStatus(); }, 60000);
      this.onVis = () => { if (!document.hidden) this.fetchStatus(); };
      document.addEventListener('visibilitychange', this.onVis);
      if ('IntersectionObserver' in window) {
        this.io = new IntersectionObserver((entries) => {
          if (entries[0].isIntersecting) { this.classList.add('is-in'); this.io.disconnect(); }
        }, { threshold: 0.2 });
        this.io.observe(this);
      } else {
        this.classList.add('is-in');
      }
    }

    disconnectedCallback() {
      clearInterval(this.poll);
      clearTimeout(this.timer);
      document.removeEventListener('visibilitychange', this.onVis);
      if (this.io) this.io.disconnect();
    }

    now() { return Date.now() + this.offset; }
    left() { return this.launch ? Math.max(0, this.launch - this.now()) : 0; }

    async fetchStatus() {
      var url = this.dataset.statusUrl;
      if (!url) return;
      try {
        var t0 = Date.now();
        var r = await fetch(url, { cache: 'no-store', credentials: 'omit' });
        if (!r.ok) return;
        var j = await r.json();
        var t1 = Date.now();
        if (j.serverNow) this.offset = Date.parse(j.serverNow) - (t0 + t1) / 2;
        if (j.launchAt) {
          this.launch = Date.parse(j.launchAt);
          if (this.when && this.dataset.preTpl) this.when.textContent = this.dataset.preTpl.replace('[date]', this.label(this.launch));
        }
        this.open = !!j.open;
        this.closed = !!j.closed;
        this.render();
      } catch (e) { /* offline or blocked: keep the built-in date */ }
    }

    /* "ביום ראשון 1.11 בשעה 10:00" in Israel time */
    label(ts) {
      var d = new Date(ts);
      var wd = new Intl.DateTimeFormat('he-IL', { weekday: 'long', timeZone: TZ }).format(d);
      var p = {};
      new Intl.DateTimeFormat('en-GB', { day: 'numeric', month: 'numeric', hour: '2-digit', minute: '2-digit', hourCycle: 'h23', timeZone: TZ })
        .formatToParts(d).forEach(function (x) { p[x.type] = x.value; });
      return 'ב' + wd + ' ' + Number(p.day) + '.' + Number(p.month) + ' בשעה\u00A0' + p.hour + ':' + p.minute;
    }

    render() {
      var state = this.closed ? 'closed' : (this.open || (this.launch && this.left() === 0)) ? 'open' : 'pre';
      if (state === this.state) return;
      this.state = state;
      this.dataset.state = state;
      var design = window.Shopify && window.Shopify.designMode;
      this.hidden = state === 'closed' && !design;
      if (this.cd) this.cd.hidden = state !== 'pre' || !this.launch;
      if (this.when) this.when.hidden = state !== 'pre';
      if (this.openLine) this.openLine.hidden = state === 'pre';
      if (this.note) this.note.hidden = state !== 'pre';
      if (this.ctaText && this.cta) this.ctaText.textContent = state === 'pre' ? this.cta.dataset.ctaPre : this.cta.dataset.ctaOpen;
    }

    launchPoll() {
      if (this.polling) return;
      this.polling = true;
      var tries = 0;
      var go = async () => {
        await this.fetchStatus();
        if (!this.open && !this.closed && ++tries < 10) setTimeout(go, 2000); else this.polling = false;
      };
      go();
    }

    tick() {
      var ms = this.left();
      if (this.state === 'pre' && this.units.length === 4) {
        var sec = Math.floor(ms / 1000);
        var v = [Math.floor(sec / 86400), Math.floor(sec / 3600) % 24, Math.floor(sec / 60) % 60, sec % 60];
        for (var i = 0; i < 4; i++) {
          var el = this.units[i];
          var t = String(v[i]).padStart(2, '0');
          if (el.textContent !== t) {
            el.textContent = t;
            if (this.painted && !this.reduce) { el.classList.remove('lpo-tick'); void el.offsetWidth; el.classList.add('lpo-tick'); }
          }
        }
        this.painted = true;
        if (this.launch && ms === 0) { this.render(); this.launchPoll(); }
      }
      this.timer = setTimeout(() => this.tick(), 1000 - (this.now() % 1000) + 10);
    }
  }

  customElements.define('lior-preorder', LiorPreorder);
})();
